/** Bumped when AMS / phase navigation UI changes — visible in header to confirm correct bundle. */
export const UI_BUILD_ID = 'wave-d-data-trust-2026-06-11';

/**
 * Frontend package.json version, shown in the sidebar footer.
 *
 * __APP_VERSION__ comes from vite `define` (see vite.config.js): inlined at
 * build time, and assigned onto globalThis by /@vite/env in dev. The typeof
 * guard keeps the module importable from a runner that applies neither.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
